module.exports = "/_next/static/images/24f057ff48078d52dee383eb9850afe8-phone-xs.png.webp";